import { setText } from "../../constants/typography";
import styles from "../../styles/ui/Emphasis.module.scss";

/*
  Two techniques instead of one bold hammer.

  · Brand lockups ("metodo ALPS", "PERCORSO ALPS") take a quiet weight step.
    They are proper nouns — they need to be recognisable, not loud.

  · Everything else — the emotional payload of a sentence — is set in Playfair
    italic inside the sans paragraph. Serif-against-sans is unmistakable at a
    glance yet far quieter than bold, and it reuses the type pairing the site
    already owns rather than adding another weight.
*/
// "ALPS", "metodo ALPS", "il PERCORSO ALPS" … all read as the brand lockup.
const BRAND = /^(il |lo |la )?((percorso|metodo)\s+)?alps[.,:;!? ]*$/i;

const Emphasis = ({ children }) => {
  const text = typeof children === "string" ? setText(children) : children;
  const isBrand = typeof text === "string" && BRAND.test(text.trim());

  if (isBrand) {
    return <strong className={styles.brand}>{text}</strong>;
  }
  return <em className={styles.phrase}>{text}</em>;
};

export default Emphasis;
